import React from 'react';
import EventsPage from './EventsPage';
import Header from '../components/Layout/Header';

const EventsPageContainer = () => {
    return (
        <>
             <Header />
            <EventsPage />
        </>
    );
};

export default EventsPageContainer;

